<template>
  <v-container>
    <v-row class="d-flex justify-center">
      <v-col>
        <v-alert
          text
          prominent
          type="error"
          icon="mdi-cloud-alert"
        >
          There has been an error
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Error'
  }
</script>
